import { render } from "./PerfilAddFamiliar.vue?vue&type=template&id=23893152"
import script from "./PerfilAddFamiliar.vue?vue&type=script&lang=ts"
export * from "./PerfilAddFamiliar.vue?vue&type=script&lang=ts"
script.render = render

export default script